import { SvgIcon, SvgIconProps } from "@mui/material";

const ArrowIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 62 58" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M53 2C52.4477 2 52 1.55228 52 1C52 0.447715 52.4477 0 53 0H62V9C62 9.55229 61.5523 10 61 10C60.4477 10 60 9.55229 60 9V3.41421L53.7071 9.70711C53.3166 10.0976 52.6834 10.0976 52.2929 9.70711C51.9024 9.31658 51.9024 8.68342 52.2929 8.29289L58.5858 2H53Z"
      fill="white"
    ></path>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 50C0.447715 50 1.49012e-08 49.5523 1.49012e-08 49C1.49012e-08 48.4477 0.447715 48 1 48H10V57C10 57.5523 9.55229 58 9 58C8.44772 58 8 57.5523 8 57V51.4142L1.70711 57.7071C1.31658 58.0976 0.683417 58.0976 0.292893 57.7071C-0.0976311 57.3166 -0.0976311 56.6834 0.292893 56.2929L6.58579 50H1Z"
      fill="white"
    ></path>
  </SvgIcon>
);
export default ArrowIcon;
